import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Certificate } from "./types";
import type { Project } from "@packages/client";

export const loadCertificatesRequest = (project: Project) =>
  apiProxyRequest<Certificate[]>(project._links?.["#certificates"].href!);
